
import React, { useEffect, useRef } from "react";


import './MahutiStepper.css'
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import stepSound from '../../sounds/newStep.wav';  


export function MahutiStepper(props) {
    const store = useSelector(state => state.reducer)
    const audioRef = useRef(null);
    const prevStepRef = useRef(null)
    const dateFlowType = store.flowType === "DATE_FLOW"
    const totalSteps = store.steps?.length || 0
    let currentStep = store.steps?.findIndex(step => step.isCurrent) + 1 || 0

    // בדיקה האם קורא מסך פעיל
    const isScreenReaderEnabled = () => {
        // בדיקת תכונת הנגישות של החלון
        if (window.accessibilityState?.isScreenReaderEnabled) {
            return true;
        }

        // בדיקת האם קיים אובייקט של NVDA
        if (window.nvda) {
            return true;
        }

        // בדיקת מאפיין ספציפי של VoiceOver
        if (/Mac/.test(navigator.platform) && /Apple/.test(navigator.vendor) && 
            document.documentElement.style.webkitUserSelect === 'none') {
            return true;
        }

        // בדיקת נוכחות של ChromeVox
        if (window.cvox) {
            return true;
        }

        // בדיקת תכונות CSS שקשורות לקוראי מסך
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (mediaQuery.matches) {
            return true;
        }

        return false;
    }

    useEffect(() => {
        audioRef.current = new Audio(stepSound);
        
        if (audioRef.current) {
            audioRef.current.volume = 0.7;
        }

        audioRef.current.load();

        return () => {
            if (audioRef.current) {
                audioRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        currentStep = store.steps?.findIndex(step => step.isCurrent) + 1 || 0;
        
        if (prevStepRef.current !== null && 
            prevStepRef.current !== currentStep) {
            
            // הפעלת הסאונד רק אם קורא מסך פעיל
            if (audioRef.current && isScreenReaderEnabled()) {
                const playSound = async () => {
                    try {
                        audioRef.current.currentTime = 0;
                        await audioRef.current.play();
                    } catch (error) {
                        console.log("Audio playback failed:", error);
                    }
                };
                playSound();
            }

            // העברת פוקוס לתוכן החדש
            const mainContent = document.querySelector('[role="main"]') || document.getElementById('main-content');
            if (mainContent) {
                mainContent.tabIndex = -1;
                mainContent.focus();
            }
        }
        prevStepRef.current = currentStep;
    }, [store.steps, currentStep]);

    return  (
                <>
                    {/* Screen reader only - announces current step */}
                    <div className="sr-only" role="status" aria-live="polite">
                        {currentStep > 0 && store.steps?.find(item => item.isCurrent) && 
                            `שלב ${currentStep} מתוך ${totalSteps}, ${store.steps.find(item => item.isCurrent).title}`
                        }
                    </div>

                    {/* Visual stepper - hidden from screen readers */}
                    <div className="mahutiStepper row justify-content-center" aria-hidden="true">
                        {!dateFlowType && <div className="col-lg-1 col d-none d-lg-block"></div>}
                            {store.steps?.map((item, index) =>
                                <div key={'li.mahutiSteppemahutiStepper__item.' + index}
                                    className={`mahutiStepper__item ${dateFlowType ? 'col-3 pe-0' : 'col-4'} col-lg-3 ` + (item.isCurrent ? 'current' : '') + ' ' + item.name}>
                                    {item.status === 'done' ? 
                                        <div className="md-step-circle "></div> :
                                        <div className="md-step-circle">
                                            <span className="text-mahuti ">{index + 1}</span>
                                        </div>
                                    }
                                    <div className="mahutiStepper_arrow col d-flex p-1">  
                                        <span className="mahutiStepper__title text-mahuti">{item.title} </span>
                                    </div>
                                        {index < props.steps.length - 1 ?
                                        <i className={`chevron-left icon ${isMobile ? '' : 'col'}`}/> :
                                            <span className="col"></span>
                                        }
                                </div>
                            )}
                        {!dateFlowType && <div className="col-lg-1 col d-none d-lg-block"></div>}
                    </div>
                </>
            )

}